// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemStack-base__feIbG{display:flex;flex-direction:column;gap:var(--size-1);width:var(--size-full);padding:var(--size-1);background:var(--surface-level-second);border-radius:var(--border-radius-2_5);box-shadow:var(--box-shadow-xs-down)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemStack-base__feIbG"
};
export default ___CSS_LOADER_EXPORT___;
